module.exports = __webpack_public_path__ + "static/fonts/ProximaNova-Semibold.9a448092.eot";